// Import Vue

import {
    createApp
} from 'vue';
// Import Framework7
import Framework7 from 'framework7/lite-bundle';
import VueI18n from '../lang'

// Import Framework7-Vue Plugin
import Framework7Vue, {
    registerComponents
} from 'framework7-vue/bundle';
import {
    f7
} from 'framework7-vue';

// Import Framework7 Styles
import 'framework7/framework7-bundle.css';

// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/app.css';

// Import App Component
import App from '../components/app.vue';
import GL_Component from "util/globalComponents";
// Init Framework7-Vue Plugin
Framework7.use(Framework7Vue);

// Init App
const app = createApp(App).use(VueI18n.i18n).use(GL_Component);

//多语言
app.config.globalProperties.$i18n = VueI18n.i18n;
app.config.globalProperties.$field = VueI18n.field;
// Register Framework7 Vue components
registerComponents(app);
// Mount the app
app.mount('#app');

